import { render, staticRenderFns } from "./ManageAccessorialCharges.vue?vue&type=template&id=2d1c4af7"
import script from "./ManageAccessorialCharges.vue?vue&type=script&lang=ts"
export * from "./ManageAccessorialCharges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports